@if (wonder$ | async; as wonder1) {
<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" aria-hidden="true">
      {{ "Health_Plans_Popup_title" | globalTranslate }}
    </h1>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  <div class="modal-body">
    <h2 class="page-header sr-only" role="heading" aria-level="1">
      {{ "Health_Plans_Popup_title" | globalTranslate }}
    </h2>
    <p>{{ "Health_Plans_Popup_text_1" | globalTranslate }}</p>
    <div class="health-plans">
      @for (w of wonder1.mcoProviderDetailsResponse; track w) {
      <div class="health-plan">
        <img
          src="{{ 'assets/images/' + w.mcoLogo }}"
          alt="'Health Plan'{{ w.mcoName }}"
        /><br />
        <div>
          <span>{{ "Health_Plans_Popup_text_2" | globalTranslate }}</span
          ><br />
          <span
            >{{ "Health_Plans_Popup_text_3_PART1" | globalTranslate }}
            {{ w.mcoName }}
            {{ "Health_Plans_Popup_text_3_PART2" | globalTranslate }}</span
          ><br />
          <b
            ><a href="{{ w.mcoUrl }}">{{ w.mcoUrl }}</a></b
          ><br /><br />
          <span>{{ "Health_Plans_Popup_text_4" | globalTranslate }}</span
          ><br /><br />
          <b>{{ w.mcoContactNumber }}</b
          ><br />
          <b>({{ "TTY" | globalTranslate }} {{ w.mcoTty }})</b><br />
        </div>
      </div>
      }
    </div>
    <p
      [innerHTML]="'Health_Plans_Popup_text_5' | globalTranslate"
      class="pb-3 pt-4 text-center"
    ></p>
  </div>
</div>
}